import { RefObject, useEffect, useRef } from 'react';

import debugLog from 'utils/debugLog.ts';

import { PlayerRef } from 'components/Player/types.ts';

type Params = {
    playerRef: RefObject<PlayerRef | null>;
    visible: boolean;
    isAirPlayConnected: boolean;
    playerPaused: boolean;
    onPlayPausePress(): void;
};

function useAirPlay({
    playerRef,
    visible,
    isAirPlayConnected,
    playerPaused,
    onPlayPausePress,
}: Params) {
    const prevIsAirPlayConnected = useRef(isAirPlayConnected);

    useEffect(() => {
        if (visible && prevIsAirPlayConnected.current && !isAirPlayConnected) {
            playerRef.current?.play();
        }

        if (
            visible &&
            !prevIsAirPlayConnected.current &&
            isAirPlayConnected &&
            playerPaused
        ) {
            onPlayPausePress();
        }

        prevIsAirPlayConnected.current = isAirPlayConnected;
    }, [isAirPlayConnected]);
}

export default useAirPlay;
